import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/legend/Header";
import { Hero } from "@/components/legend/Hero";
import { Timeline } from "@/components/legend/Timeline";
import { MediaSponsor } from "@/components/legend/MediaSponsor";
import { MagazineTicker } from "@/components/legend/MagazineTicker";
import { ClubVillage } from "@/components/legend/ClubVillage";
import { Gallery } from "@/components/legend/Gallery";
import { Academy } from "@/components/legend/Academy";
import { Testimonials } from "@/components/legend/Testimonials";
import { MapSection } from "@/components/legend/MapSection";
import { ContactSection } from "@/components/legend/ContactSection";
import PaymentSuccess, { PaymentCancel } from "@/pages/PaymentResult";
import Segreteria from "@/pages/Segreteria";
import Gare, { GaraDettaglio } from "@/pages/Gare";
import Interviste, { IntervistaDettaglio } from "@/pages/Interviste";
import { GareTicker, IntervisteTicker } from "@/components/legend/HomeTickers";
import { Footer } from "@/components/legend/Footer";

const HomePage = () => (
  <div
    data-testid="legend-home"
    className="min-h-screen bg-neutral-950 text-neutral-100 antialiased selection:bg-red-600 selection:text-white"
  >
    <Header />
    <Hero />
    <Timeline />
    <IntervisteTicker />
    <MagazineTicker />
    <GareTicker />
    <MediaSponsor />
    <ClubVillage />
    <Gallery />
    <Academy />
    <Testimonials />
    <MapSection />
    <ContactSection />
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <Toaster theme="dark" position="bottom-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/segreteria" element={<Segreteria />} />
          <Route path="/gare" element={<Gare />} />
          <Route path="/gare/:slug" element={<GaraDettaglio />} />
          <Route path="/interviste" element={<Interviste />} />
          <Route path="/interviste/:slug" element={<IntervistaDettaglio />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
